import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: ["title" ,"data","labelChart" ,"backgroundColor"],
  data() {
    return {
      chartdata: {
         labels:this.labelChart,
        // labels: ['[8%,14%]', '(14%,21%]', '(21%,34%]', '(34%,40%]', '(40%,47%]', '(47%,53%]', '(53%,14%]', '(53%,60%]', '(60%,66%]', '(66%,73%]', '(73%,79%]'],
        datasets: [{
          label: `${this.title}`,
          data: this.data,
          backgroundColor:this.backgroundColor,
          // borderColor: [
          //   '#ff0000',
          //   '#ff0000',
          //   '#ff0000',
          //   '#ff0000',
          //   '#ff0000',
          //   '#ff0000',
          //   '#ffc107',
          //   '#ffc107',
          //   '#ffc107',
          //   '#ffc107',
          //   '#ffc107',
          //   '#ffc107',
          //   '#ffc107',
          //   '#ffc107',
          //   '#ffc107',
          //   '#ffc107',
          //   '#28a745f2',
          //   '#28a745f2',
          //   '#28a745f2',
          //   '#28a745f2',
          //   '#28a745f2',
          // ],
          borderWidth: 1,
          fontFamily: "IRANSans"
        }]
      },
      options: {
        legend: {
          fontFamily: "IRANSans",
          display: false,
          labels: {
            fontSize: 20
          },
          title: {
            display: true,
            text: "Legend Title"
          }
        },
        title: {
          display: !!this.title,
          text: `${this.title}`,
          position: "top",
          fontSize: 16, // default font size is 12px
          fontFamily: "IRANSans", // text font family
          // fontColor:'#666'
          fontStyle: "bold" // font style
          // padding: 10 // number of pixels in the text above and below the title added
          // lineHeight: height 10 // single line of text
        },
        //   scales: {
        //     y: {
        //         beginAtZero: true
        //     }
        //  },
        scales: {
          yAxes: [
            {
              display: false,
              ticks: {
                beginAtZero: true,
                fontFamily: "IRANSans"
              },
              gridLines: {
                display: true,
                drawBorder: false
              }
            }
          ],
          xAxes: [
            {
              
              categoryPercentage: 1.0,
              barPercentage: 1.0,
              ticks: {
                beginAtZero: true,
                fontFamily: "IRANSans"
              },
              gridLines: {
                display: false,
                drawBorder: false
              }
            }
          ]
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
        tooltips: {
          enabled: true,
          mode: "single",
          callbacks: {
            label: function(tooltipItems, data) {
              return tooltipItems.yLabel;
            }
          }
        }
      }
    };
  },

  mounted() {
    this.renderChart(this.chartdata, this.options);
  }
};
